<template>
  <div class="table">
    <div class="container">
      <div>
        <p class="icon-jujue closeBtn" @click="routerBack"></p>
      </div>
      <div class="handle-box" v-if="isMy">
        <el-row type="flex" align="middle">
          <el-button v-acl="RMC_PROT_MEDICINE_SAVE" v-if="detailInfo.status=='DRAFT'" size="mini" type="primary" @click="saveData('detailInfo')">保存</el-button>
          <el-button v-acl="RMC_PROT_MEDICINE_SUBMIT" v-if="detailInfo.status=='DRAFT'||detailInfo.status=='PASS'||detailInfo.status=='BACK'&&statusView=='S'" size="mini" type="primary" @click="submitData('detailInfo')">提交</el-button>
          <el-button v-acl="RMC_PROT_MEDICINE_APPROVE" v-if="!statusVal" size="mini" type="primary" @click="approve">批准</el-button>
          <el-button v-acl="RMC_PROT_MEDICINE_RETURN" v-if="!statusVal" size="mini" type="primary" @click="sendBack">退回</el-button>
        </el-row>
      </div>
      <div class="handle-box" style="padding-bottom:10px;">
        <div class="info_box_title" style="padding-left:10px;box-sizing: border-box;">
          <p class="line"></p>
          <p class="info_title">药品清单</p>
        </div>
        <el-form :model="detailInfo" ref="detailInfo" :rules="rules" label-position="right" label-width="120px" class="searchForm">
          <el-row :gutter="20">
            <el-col :span="6">
              <el-form-item label="Category3" prop="category3Code">
                <el-select v-model="detailInfo.category3Code" @change="getCategory3Name" :disabled="category3List.length>1&&isDisabled&&isSet?false:true" clearable style="width:100%" placeholder="请选择">
                  <el-option :key="index" v-for="(item,index) in category3List" :label="item.object" :value="item.key"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="Sponsor">
                <el-input v-model="detailInfo.sponsorName" disabled placeholder="从供应商集团选择">
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="ASL Group" prop="aslGroupCode">
                <el-select v-model="detailInfo.aslGroupCode" :disabled="isDisabled&&isSet?false:true" @change="getAslName" clearable style="width:100%" placeholder="请选择">
                  <el-option :key="index" v-for="(item,index) in aslGroupCodeList" :label="item.aslGroupName" :value="item.aslGroupCode" :disabled="!item.enabled"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="状态">
                <ic-select table="TT_RMC_PROTEIN_MEDICINE" disabled filterable field="STATUS" clearable v-model="detailInfo.status" style="width:100%"></ic-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="24">
              <el-form-item label="有效成分" prop="effectiveComponents">
                <el-select v-model="detailInfo.effectiveComponents" filterable :disabled="isDisabled&&isSet?false:true" @change="getOther" clearable style="width:100%" placeholder="请选择">
                  <el-option :key="index" v-for="(item,index) in effectiveComponentsList" :label="item.name" :value="item.code"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6" v-if="isOther">
              <el-form-item label="有效成分其他" prop="effectiveComponentsOther">
                <el-input v-model="detailInfo.effectiveComponentsOther" :disabled="isDisabled&&isSet?false:true" placeholder="请输入内容"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="药品一级分类" prop="medicineLevelOneGrade">
                <el-select :disabled="isOther&&isDisabled&&isSet?false:true" v-model="detailInfo.medicineLevelOneGrade" clearable style="width:100%" placeholder="请选择">
                  <el-option :key="index" v-for="(item,index) in medicineLevelOneGradeList" :label="item.name" :value="item.code"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="isOther?6:12">
              <el-form-item label="药品二级分类" prop="medicineLevelTwoGrade">
                <el-select :disabled="isOther&&isDisabled&&isSet?false:true" v-model="detailInfo.medicineLevelTwoGrade" clearable style="width:100%" placeholder="请选择">
                  <el-option :key="index" v-for="(item,index) in medicineLevelTwoGradeList" :label="item.name" :value="item.code"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="6">
              <el-form-item label="WHO药品等级" prop="whoMedicineGrade">
                <el-select :disabled="isOther&&isDisabled&&isSet?false:true" v-model="detailInfo.whoMedicineGrade" clearable style="width:100%" placeholder="请选择">
                  <el-option :key="index" v-for="(item,index) in whoMedicineGradeList" :label="item.name" :value="item.code"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="OIE药物等级" prop="oieMedicineGrade">
                <el-select :disabled="isOther&&isDisabled&&isSet?false:true" v-model="detailInfo.oieMedicineGrade" clearable style="width:100%" placeholder="请选择">
                  <el-option :key="index" v-for="(item,index) in oieMedicineGradeList" :label="item.name" :value="item.code"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="通用名" prop="commonName">
                <el-autocomplete class="inline-input" maxlength="100" style="width:100%" v-model="detailInfo.commonName" :disabled="isDisabled&&isSet?false:true" :fetch-suggestions="querySearch" placeholder="请输入内容" :trigger-on-focus="false" @select="handleSelect"></el-autocomplete>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="商品名" prop="productName">
                <el-autocomplete class="inline-input" maxlength="100" style="width:100%" v-model="detailInfo.productName" :disabled="isDisabled&&isSet?false:true" :fetch-suggestions="querySearch1" placeholder="请输入内容" :trigger-on-focus="false" @select="handleSelect1"></el-autocomplete>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="6">
              <el-form-item label="兽药批准文号" prop="approvelNumber">
                <el-input v-model="detailInfo.approvelNumber" maxlength="100" :disabled="isDisabled&&isSet?false:true" placeholder="请输入内容"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="有效成分和含量" prop="effectiveComponentsContent">
                <el-input v-model="detailInfo.effectiveComponentsContent" maxlength="300" :disabled="isDisabled&&isSet?false:true" placeholder="请输入内容"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="适应症" prop="indication">
                <el-input v-model="detailInfo.indication" maxlength="100" :disabled="isDisabled&&isSet?false:true" placeholder="请输入内容"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="生产厂家" prop="producer">
                <el-input v-model="detailInfo.producer" maxlength="100" :disabled="isDisabled&&isSet?false:true" placeholder="请输入内容"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="6">
              <el-form-item label="规格" prop="specification">
                <el-input v-model="detailInfo.specification" maxlength="100" :disabled="isDisabled&&isSet?false:true" placeholder="请输入内容"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="用法和用量" prop="usage">
                <el-input v-model="detailInfo.usage" maxlength="300" :disabled="isDisabled&&isSet?false:true" placeholder="请输入内容"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="休药期(天)" prop="withdrawalDay">
                <el-input v-model.number="detailInfo.withdrawalDay" maxlength="10" :disabled="isDisabled&&isSet?false:true" placeholder="请输入内容"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="最新检测时间">
                <el-date-picker style="width:100%;" v-model="detailInfo.lastDetectionTime" :disabled="isDisabled&&isSet?false:true" format="yyyy-MM-dd" value-format="yyyy-MM-dd" type="date" placeholder="选择日期"> </el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="6">
              <el-form-item label="药品在用状态" prop="medicineUseStatus">
                <ic-select table="TT_RMC_PROTEIN_MEDICINE" filterable field="MEDICINE_USE_STATUS" :disabled="isDisabled&&isSet?false:true" clearable v-model="detailInfo.medicineUseStatus" style="width:100%"></ic-select>
              </el-form-item>
            </el-col>
            <el-col v-if="detailInfo.category3Code == '10101'" :span="6">
              <el-form-item label="养殖模式" prop="breedingMode">
<!--                <ic-select table="TT_RMC_PROTEIN_MEDICINE" filterable field="MEDICINE_USE_STATUS" :disabled="isDisabled&&isSet?false:true" clearable v-model="detailInfo.farmingMode" style="width:100%"></ic-select>-->
                <el-select v-model="detailInfo.breedingMode" :disabled="isDisabled&&isSet?false:true" clearable placeholder="请选择" style="width:100%">
                  <el-option :key="index" v-for="(item,index) in breedingModeOptions" :label="item.object" :value="item.key"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="24" v-if="$route.query.id">
              <el-form-item label="上次修改原因" prop="momentUpdateReason">
                <el-input type="textarea" maxlength="1000" show-word-limit placeholder="请输入内容" disabled v-model="momentUpdateReason"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="24">
              <el-form-item label="修改原因" prop="modifyReason">
                <el-tooltip v-if="detailInfo.modifyReason&&detailInfo.modifyReason.length>400" class="item" effect="dark" :content="detailInfo.modifyReason" placement="top-start">
                  <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 4}" maxlength="1000" show-word-limit placeholder="请输入内容" :disabled="isDisabled&&isSet?false:true" v-model="detailInfo.modifyReason"></el-input>
                </el-tooltip>
                <el-input v-else type="textarea" :autosize="{ minRows: 2, maxRows: 4}" maxlength="1000" show-word-limit placeholder="请输入内容" :disabled="isDisabled&&isSet?false:true" v-model="detailInfo.modifyReason"></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <!-- <el-row style="margin-top:8px;"  align="middle">
             <el-col :span="6">
                 <el-form-item label="Category3" prop="category3Code">
                    <el-select v-model="detailInfo.category3Code" @change="getCategory3Name" :disabled="category3List.length>1&&isDisabled&&isSet?false:true" clearable style="width:100%" placeholder="请选择">
                      <el-option :key="index" v-for="(item,index) in category3List" :label="item.object" :value="item.key"></el-option>
                    </el-select>
                 </el-form-item>
             </el-col>
             <el-col :span="6">
                 <el-form-item label="Sponsor">
                   <el-input v-model="detailInfo.sponsorName" disabled placeholder="从供应商集团选择" >
                    </el-input>
                 </el-form-item>
             </el-col>
             <el-col :span="6">
                 <el-form-item label="ASL Group" prop="aslGroupCode">
                     <el-select v-model="detailInfo.aslGroupCode" :disabled="isDisabled&&isSet?false:true" @change="getAslName" clearable style="width:100%" placeholder="请选择">
                        <el-option :key="index" v-for="(item,index) in aslGroupCodeList" :label="item.aslGroupName" :value="item.aslGroupCode" :disabled="!item.enabled"></el-option>
                      </el-select>
                 </el-form-item>
             </el-col>
             <el-col :span="6">
                 <el-form-item label="状态">
                    <ic-select table="TT_RMC_PROTEIN_MEDICINE" disabled filterable field="STATUS" clearable v-model="detailInfo.status"  style="width:100%"></ic-select>
                 </el-form-item>
             </el-col>
             <el-col :span="6">
                 <el-form-item label="有效成分" prop="effectiveComponents">
                     <el-select v-model="detailInfo.effectiveComponents" filterable :disabled="isDisabled&&isSet?false:true" @change="getOther" clearable style="width:100%" placeholder="请选择">
                        <el-option :key="index" v-for="(item,index) in effectiveComponentsList" :label="item.name" :value="item.code"></el-option>
                      </el-select>
                 </el-form-item>
             </el-col>
            <el-col :span="6" v-if="isOther">
                 <el-form-item label="有效成分其他" prop="effectiveComponentsOther">
                     <el-input v-model="detailInfo.effectiveComponentsOther" :disabled="isDisabled&&isSet?false:true" placeholder="请输入内容"></el-input>
                 </el-form-item>
             </el-col>

             <el-col :span="6">
                 <el-form-item label="药品一级分类" prop="medicineLevelOneGrade">
                     <el-select :disabled="isOther&&isDisabled&&isSet?false:true" v-model="detailInfo.medicineLevelOneGrade" clearable style="width:100%" placeholder="请选择">
                        <el-option :key="index" v-for="(item,index) in medicineLevelOneGradeList" :label="item.name" :value="item.code"></el-option>
                      </el-select>
                 </el-form-item>
             </el-col>
             <el-col :span="isOther?6:12">
                 <el-form-item label="药品二级分类" prop="medicineLevelTwoGrade">
                     <el-select :disabled="isOther&&isDisabled&&isSet?false:true" v-model="detailInfo.medicineLevelTwoGrade" clearable style="width:100%" placeholder="请选择">
                        <el-option :key="index" v-for="(item,index) in medicineLevelTwoGradeList" :label="item.name" :value="item.code"></el-option>
                      </el-select>
                 </el-form-item>
             </el-col>
             <el-col :span="6">
                 <el-form-item label="WHO药品等级" prop="whoMedicineGrade">
                     <el-select :disabled="isOther&&isDisabled&&isSet?false:true" v-model="detailInfo.whoMedicineGrade" clearable style="width:100%" placeholder="请选择">
                        <el-option :key="index" v-for="(item,index) in whoMedicineGradeList" :label="item.name" :value="item.code"></el-option>
                      </el-select>
                 </el-form-item>
             </el-col>
             <el-col :span="6">
                 <el-form-item label="OIE药物等级" prop="oieMedicineGrade">
                     <el-select :disabled="isOther&&isDisabled&&isSet?false:true" v-model="detailInfo.oieMedicineGrade" clearable style="width:100%" placeholder="请选择">
                        <el-option :key="index" v-for="(item,index) in oieMedicineGradeList" :label="item.name" :value="item.code"></el-option>
                     </el-select>
                 </el-form-item>
             </el-col>
             <el-col :span="6">
                 <el-form-item label="通用名" prop="commonName">
                   <el-autocomplete class="inline-input" maxlength="100" v-model="detailInfo.commonName" :disabled="isDisabled&&isSet?false:true" :fetch-suggestions="querySearch" placeholder="请输入内容" :trigger-on-focus="false" @select="handleSelect" ></el-autocomplete>
                 </el-form-item>
             </el-col>
             <el-col :span="6">
                 <el-form-item label="商品名" prop="productName">
                   <el-autocomplete class="inline-input" maxlength="100" v-model="detailInfo.productName" :disabled="isDisabled&&isSet?false:true" :fetch-suggestions="querySearch1" placeholder="请输入内容" :trigger-on-focus="false" @select="handleSelect1" ></el-autocomplete>
                 </el-form-item>
             </el-col>
             <el-col :span="6">
                 <el-form-item label="兽药批准文号" prop="approvelNumber">
                     <el-input v-model="detailInfo.approvelNumber" maxlength="100" :disabled="isDisabled&&isSet?false:true" placeholder="请输入内容"></el-input>
                 </el-form-item>
             </el-col>
             <el-col :span="6">
                 <el-form-item label="有效成分和含量" prop="effectiveComponentsContent">
                     <el-input v-model="detailInfo.effectiveComponentsContent" maxlength="100" :disabled="isDisabled&&isSet?false:true" placeholder="请输入内容"></el-input>
                 </el-form-item>
             </el-col>
             <el-col :span="6">
                 <el-form-item label="适应症" prop="indication">
                    <el-input v-model="detailInfo.indication" maxlength="100" :disabled="isDisabled&&isSet?false:true" placeholder="请输入内容"></el-input>
                 </el-form-item>
             </el-col>
             <el-col :span="6">
                 <el-form-item label="生产厂家" prop="producer">
                     <el-input v-model="detailInfo.producer" maxlength="100" :disabled="isDisabled&&isSet?false:true" placeholder="请输入内容"></el-input>
                 </el-form-item>
             </el-col>
             <el-col :span="6">
                 <el-form-item label="规格" prop="specification">
                     <el-input v-model="detailInfo.specification" maxlength="100" :disabled="isDisabled&&isSet?false:true" placeholder="请输入内容"></el-input>
                 </el-form-item>
             </el-col>
             <el-col :span="6">
                 <el-form-item label="用法和用量" prop="usage">
                     <el-input v-model="detailInfo.usage" maxlength="100" :disabled="isDisabled&&isSet?false:true" placeholder="请输入内容"></el-input>
                 </el-form-item>
             </el-col>
             <el-col :span="6">
                 <el-form-item label="休药期(天)" prop="withdrawalDay">
                     <el-input v-model.number="detailInfo.withdrawalDay" maxlength="10"  :disabled="isDisabled&&isSet?false:true" placeholder="请输入内容"></el-input>
                 </el-form-item>
             </el-col><el-col :span="6">
                 <el-form-item label="最新检测时间" prop="lastDetectionTime">
                     <el-date-picker style="width:100%;" v-model="detailInfo.lastDetectionTime" :disabled="isDisabled&&isSet?false:true" format="yyyy-MM-dd" value-format="yyyy-MM-dd" type="date" placeholder="选择日期"> </el-date-picker>
                 </el-form-item>
             </el-col>
             <el-col :span="6">
                 <el-form-item label="药品在用状态" prop="medicineUseStatus">
                    <ic-select table="TT_RMC_PROTEIN_MEDICINE" filterable field="MEDICINE_USE_STATUS" :disabled="isDisabled&&isSet?false:true" clearable v-model="detailInfo.medicineUseStatus"  style="width:100%"></ic-select>
                 </el-form-item>
             </el-col>
              <el-col :span="24" v-if="$route.query.id">
                 <el-form-item label="上次修改原因" prop="momentUpdateReason">
                    <el-input  type="textarea"  maxlength="1000" show-word-limit placeholder="请输入内容"  disabled v-model="momentUpdateReason"></el-input>
                 </el-form-item>
             </el-col>
             <el-col :span="24">
                 <el-form-item label="修改原因" prop="modifyReason">
                   <el-tooltip v-if="detailInfo.modifyReason&&detailInfo.modifyReason.length>400" class="item" effect="dark" :content="detailInfo.modifyReason" placement="top-start">
                    <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 4}" maxlength="1000" show-word-limit placeholder="请输入内容"  :disabled="isDisabled&&isSet?false:true" v-model="detailInfo.modifyReason"></el-input>
                   </el-tooltip>
                    <el-input v-else type="textarea" :autosize="{ minRows: 2, maxRows: 4}" maxlength="1000" show-word-limit placeholder="请输入内容"  :disabled="isDisabled&&isSet?false:true" v-model="detailInfo.modifyReason"></el-input>
                 </el-form-item>
             </el-col>
          </el-row> -->
        </el-form>
      </div>

      <div class="handle-box" style="margin-top:20px;">
        <div class="info_box_title" style="padding-left:10px;box-sizing: border-box;">
          <p class="line"></p>
          <p class="info_title">检测报告</p>
        </div>
        <el-row type="flex" style="margin-top:10px;" align="middle">
          <el-button :disabled="isDisabled&&isSet?false:true" v-acl="RMC_PROT_MEDICINE_UPLOAD" size="small" type="primary" @click="openFile">
            {{$t('common.selectFile')}}
          </el-button>
        </el-row>
        <el-table ref="plxTable" :data="fileList" style="margin-top:10px;" max-height="500" show-overflow="ellipsis" highlight-current-row>
          <el-table-column align="center" label="文件名称" prop="documentName">
            <template slot-scope="scope">
              <el-button @click="onDownload(scope.row)" type="text" size="small">{{scope.row.documentName}}</el-button>
            </template>
          </el-table-column>
          <el-table-column label="附件描述" align="center" prop="docComments">
            <template slot-scope="scope">
              <el-tooltip class="item" effect="dark" :content="scope.row.docComments" placement="top-start">
                <span style="display: inline-block;maxHeight: 80px;padding:10px 0px;box-sizing: border-box;">{{scope.row.docComments}}</span>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column label="上传人" align="center" prop="userName"></el-table-column>
          <el-table-column label="上传时间" align="center" prop="createDate"></el-table-column>
          <el-table-column label="操作" align="center" prop="updateDate" v-if="isDisabled&&isSet">
            <template v-slot="scope">
              <i class="el-icon-delete" style="color: red;" @click="delFile(scope.row)"></i>
            </template>
          </el-table-column>
        </el-table>

      </div>

      <el-dialog title="Facility列表" :visible.sync="dialogVisible" width="85%" :before-close="handleClose">
        <facilityList v-if="dialogVisible" @selectData="selectData"></facilityList>
      </el-dialog>

      <el-dialog title="提示" :visible.sync="fileVisible" width="30%" :before-close="closeFile">
        <uploadFile v-if="fileVisible" @close="closeFile" :detailInfo="detailInfo" :tsReckindId="tsReckindId"></uploadFile>
      </el-dialog>

    </div>
  </div>
</template>
<script>
import store from '@/store/index'

import IcSelect from "@/components/common/icSelect";
import ratingTask from "@/api/AAA/ratingTask.js";
import QBRApi from "@/api/QBR/index";
import commonFun from "@/utils/commonFun";
import commonFunction from "@/utils/dataTableUtils";
import rules from '@/components/page/RMC/Protein/rmcDrugList/rules'
import proteinDrug from "@/api/rmcProtein/drug";
import facilityList from "../ASL/facilityList.vue";
import { fileService } from "@/api/common/file-utils"
import { _debounce } from '@/components/common/reduce'

import aslApi from "@/api/rmcProtein/asl";
import uploadFile from "./dialog/uploadFile.vue"

export default {
  name: '',
  components: {
    uploadFile,
    IcSelect,
    facilityList,
    // detailDialog
  },
  data() {
    return {
      isSet: false,
      supplierObj: null,
      momentUpdateReason: "",
      commonNames: [],
      productNames: [],
      fileVisible: false,
      header: {
        'x-access-token': localStorage.getItem('token')
      },
      detailInfo: {
        status: "DRAFT",
        attachment: {}
      },
      effectiveComponentsList: [],
      medicineLevelOneGradeList: [],
      medicineLevelTwoGradeList: [],
      whoMedicineGradeList: [],
      oieMedicineGradeList: [],
      aslGroupCodeList: [],
      isOther: false,
      identity: localStorage.getItem('ms_emplFlag'),
      multipleSelection: [],
      categoryList2: [],
      categoryList3: [],
      category3List: [],
      statusList: [],
      fileTable: [],
      isShow: false,
      formData: null,
      totalCount: "",
      rules: rules,
      fileList: [],
      tsReckindId: "",
      statusVal: "",
      statusView: "",
      isDisabled: '',
      dialogVisible: false,
      breedingModeOptions: [],
      isMy: true,
    }
  },
  created() {
    this.supplierObj = JSON.parse(localStorage.getItem("supplierObj"));
    let functions = store.state.main.functions;
    this.getCommonNames()
    this.getProductNames()
    if (!this.$route.query.id) {
      this.detailInfo.medicineLevelOneGrade = '抗生素'
      this.getSponsorByUser()
      this.statusVal = 'All'
      this.isDisabled = true
      this.isSet = true
    } else {
      if (functions.indexOf('RMC_PROT_MEDICINE_SAVE') != -1 || functions.indexOf('RMC_PROT_MEDICINE_SUBMIT') != -1) {
        this.isSet = true
      }
      this.getDetailInfo()
    }
    this.getdCategory3()
    this.getDrugGrade()

    let ms_roles = JSON.parse(localStorage.getItem("ms_roles"));
    if (this.identity == 'SUP') {   //判断是供应商
      this.statusView = 'S';
    } else {
      if (ms_roles.indexOf("QSPI_RMC_PROTEIN_CQS") != -1) {
        this.statusView = 'C'
      }
    }
    console.log("statusViewstatusView", this.statusView)
    console.log("创建时候的===", this.statusVal)
  },
  mounted() {

  },
  computed: {
    fileUploadUrl() {
      return 'adminconsole/file/PROTEIN_MEDICINE/' + this.detailInfo.ttRmcProteinMedicineId
    },
  },
  methods: {

    onDownload(row) {
      fileService.downloadFile(row).then((res) => { })
    },
    openFile() {
      this.tsReckindId = 'PROTEIN_MEDICINE'
      this.fileVisible = true
    },
    uploadSuccess(response, file, fileList) {
      if (response.code === '200') {
        this.$message.success('上传成功')
        this.getFileLists()
      }
    },
    beforeUpload(file) {
      const isLt50M = file.size / 1024 / 1024 < 50;
      if (!isLt50M) {
        this.$my_message(this.$t('prompt.imageFileSize'), 'error');
      }
      return isLt50M;
    },
    getDetailInfo() {
      proteinDrug.getDrugInfo({}, this.$route.query.id).then((res) => {
        if (res.data.status == 'PENDING') {
          this.statusVal = ''
          this.isDisabled = false
        } else if (res.data.status == 'DRAFT') {
          this.statusVal = 'All'
          this.isDisabled = true
        } else if (res.data.status == 'PASS') {
          this.statusVal = 'P'
          this.isDisabled = true
        } else if (res.data.status == 'BACK') {
          this.statusVal = 'B'
          if (this.statusView == 'S') {
            this.isDisabled = true
          } else {
            this.isDisabled = false
          }
        }
        if (res.data.modifyReason) {
          this.momentUpdateReason = res.data.modifyReason
          res.data.modifyReason = ''
        }
        // this.filterBtn(res.data.status)
        this.detailInfo = res.data
        this.getAslGroup(res.data.sponsorCode, res.data.aslGroupCode)
        this.getFileLists()
        if(this.detailInfo.aslGroupCode) {
          this.getBreedingModeList(this.detailInfo.aslGroupCode)
        }
        if(this.supplierObj.supperSupplierCode != res.data.sponsorCode) {
          this.isDisabled = true
          this.isSet = false
          this.isMy = false;
        }

        console.log("获取的详情数据====", res)
      })
    },
    filterBtn(val) {
      // "待审批"  PENDING
      // 草稿    DRAFT
      // 批准   PASS
      // 退回   BACK
      if (val == 'PENDING') {
        this.statusVal = ''
        this.isDisabled = false
      } else if (val == 'DRAFT') {
        this.statusVal = 'All'
        this.isDisabled = true
      } else if (val == 'PASS') {
        this.statusVal = 'P'
        this.isDisabled = true
      } else if (val == 'BACK') {
        this.statusVal = 'B'
        if (this.statusView == 'S') {
          this.isDisabled = true
        } else {
          this.isDisabled = false
        }
      }
    },
    getCommonNames() {
      proteinDrug.getCommonNames().then((res) => {
        this.commonNames = res.data
      })
    },
    getProductNames() {
      proteinDrug.getProductNames().then((res) => {
        this.productNames = res.data
      })
    },
    queryEffectiveComponents: _debounce(function (queryString, cb) {
      let arr = []
      this.effectiveComponentsList.forEach((v) => {
        let obj = {}
        obj.value = v.code
        arr.push(obj)
      })
      var results = arr.filter((a) => {
        return a.value.indexOf(queryString) != -1
      })
      cb(results)
    }, 50),
    selectEffectiveComponents(item) {
      console.log(item);
    },
    querySearch: _debounce(function (queryString, cb) {
      let arr = []
      this.commonNames.forEach((v) => {
        let obj = {}
        obj.value = v
        arr.push(obj)
      })
      var results = arr.filter((a) => {
        return a.value.indexOf(queryString) != -1
      })
      cb(results)
    }, 50),
    handleSelect(item) {
      console.log(item);
    },
    querySearch1: _debounce(function (queryString, cb) {
      let arr = []
      this.productNames.forEach((v) => {
        let obj = {}
        obj.value = v
        arr.push(obj)
      })
      var results = arr.filter((a) => {
        return a.value.indexOf(queryString) != -1
      })
      cb(results)
    }, 50),
    handleSelect1(item) {
      console.log(item);
    },
    getSponsorByUser() {
      proteinDrug.getSponsorByUser().then((res) => {
        this.$set(this.detailInfo, "sponsorName", res.data.supplierName)
        this.$set(this.detailInfo, "sponsorCode", res.data.supplierCode)
        this.getAslGroup(res.data.supplierCode)
      })
    },
    getDrugGrade() {
      proteinDrug.queryNatureForSelect().then((res) => {
        // 有效成分
        res.data.effectiveComponentsList.forEach((v) => {
          let obj = {}
          obj.name = v
          obj.code = v
          this.effectiveComponentsList.push(obj)
        })
        // 药品一级分类
        res.data.medicineLevelOneGradeList.forEach((v) => {
          let obj = {}
          obj.name = v
          obj.code = v
          this.medicineLevelOneGradeList.push(obj)
        })
        // 药品二级分类
        res.data.medicineLevelTwoGradeList.forEach((v) => {
          let obj = {}
          obj.name = v
          obj.code = v
          this.medicineLevelTwoGradeList.push(obj)
        })
        // WHO药品等级
        res.data.whoMedicineGradeList.forEach((v) => {
          let obj = {}
          obj.name = v
          obj.code = v
          this.whoMedicineGradeList.push(obj)
        })
        // OIE药物等级
        res.data.oieMedicineGradeList.forEach((v) => {
          let obj = {}
          obj.name = v
          obj.code = v
          this.oieMedicineGradeList.push(obj)
        })
      })
    },
    getdCategory3() {
      proteinDrug.getdCategory3().then((res) => {
        this.category3List = res.data.filter((v) => {
          return v.cascadeKey == 'protein'
        })
        if (this.category3List.length == 1) {
          this.$set(this.detailInfo, 'category3Code', this.category3List[0].key)
          this.$set(this.detailInfo, 'category3Name', this.category3List[0].object)
          this.$refs['detailInfo'].clearValidate(['category3Code']);
        }
      })
    },
    delFile(file, index) {
      if (file.tmDocumentId) {
        fileService.deleteFile(file.tmDocumentId).then((res) => {
          if (res.code === '200') {
            this.fileList.splice(index, 1);
            this.getFileLists()
          }
        })
      } else {
        this.fileList.splice(index, 1);
      }
    },
    closeFile(val, data) {
      this.fileVisible = false
      if (val && data.length > 0) {
        data[0].docComments = val.docComments
        this.fileList = this.fileList.concat(data)
        this.detailInfo.attachment.tsReckindId = "PROTEIN_MEDICINE"
        this.detailInfo.attachment.tsRecId = this.detailInfo.ttRmcProteinMedicineId ? this.detailInfo.ttRmcProteinMedicineId : null
        this.detailInfo.attachment.documents = this.fileList
        // this.fileList.push(obj)
      }
      // this.getFileLists()
    },
    getFileLists() {
      QBRApi.getFileLists({
        tsReckindId: "PROTEIN_MEDICINE",
        tsRecId: this.detailInfo.ttRmcProteinMedicineId
      }).then(res => {
        console.log('获取列表', res);
        this.fileList = res
      });
    },
    selectionChange(val) {
      this.multipleSelection = val
    },
    getCategory3Lists() {
      var param = {
        categoryLevel: '3',
      }
      QBRApi.getCategoryLists(param).then(res => {
        this.categoryList3 = res.data
      });
    },
    getAslName(val) {
      if(val) {
        let name = this.aslGroupCodeList.filter((a) => { return a.aslGroupCode == val })
        this.$set(this.detailInfo, 'aslGroupName', name[0].aslGroupName)
        this.getBreedingModeList(val)
      } else {
        this.breedingModeOptions = [];
        this.detailInfo.breedingMode = "";
      }
    },
    // 根据asl group code获取对应的养殖模式
    getBreedingModeList(val) {
      proteinDrug.getMedicineBreedingModeByAslGroup({aslGroupCode: val}).then(res => {
        this.breedingModeOptions = res?res:[]
      })
    },
    // 保存
    saveData(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (!this.detailInfo.modifyReason) {
            this.detailInfo.modifyReason = this.momentUpdateReason
          }
          proteinDrug.saveDrugList(this.detailInfo).then((res) => {
            if (res.code == 200) {
              this.$message.success('保存成功')
              this.routerBack()
            } else {
              this.$message.error(res.msg)
            }
          })
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    approve() {
      if (!this.detailInfo.modifyReason) {
        this.detailInfo.modifyReason = this.momentUpdateReason
      }
      proteinDrug.approverDrugList(this.detailInfo).then((res) => {
        if (res.code == 200) {
          this.$message.success('批准成功')
          this.routerBack()
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    sendBack() {
      if (!this.detailInfo.modifyReason) {
        this.detailInfo.modifyReason = this.momentUpdateReason
      }

      this.$prompt('', '请填写退回意见', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputValidator: (value) => {
          if (!value) {
            return '退回意见不能为空！';
          }
        },
      }).then(({ value }) => {
        this.detailInfo.opinion = value
        proteinDrug.backDrugList(this.detailInfo).then((res) => {
          if (res.code == 200) {
            this.$message.success('退回成功')
            this.routerBack()
          } else {
            this.$message.error(res.msg)
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '取消输入'
        });
      });

    },
    getCategory3Name(val) {
      let getName = this.category3List.filter((v) => {
        return v.key == val
      })
      this.detailInfo.category3Name = getName[0].object
    },
    // 提交
    submitData(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (!this.detailInfo.modifyReason) {
            this.detailInfo.modifyReason = this.momentUpdateReason
          }
          if (this.detailInfo.lastDetectionTime) {
            if (this.fileList.length > 0) {
              proteinDrug.submitDrugList(this.detailInfo).then((res) => {
                if (res.code == 200) {
                  this.$message.success('提交成功')
                  this.routerBack()
                } else {
                  this.$message.error(res.msg)
                }
              })
            } else {
              this.$message.error(this.detailInfo.productName + '药品检测报告未上传，请检查。')
            }
          } else {
            proteinDrug.submitDrugList(this.detailInfo).then((res) => {
              if (res.code == 200) {
                this.$message.success('提交成功')
                this.routerBack()
              } else {
                this.$message.error(res.msg)
              }
            })
          }
          // if(this.fileList.length>0&&this.detailInfo.lastDetectionTime){
          //   if(!this.detailInfo.modifyReason){
          //     this.detailInfo.modifyReason=this.momentUpdateReason
          //   }
          //   proteinDrug.submitDrugList(this.detailInfo).then((res)=>{
          //     if(res.code==200){
          //       this.$message.success('提交成功')
          //       this.routerBack()
          //     }else{
          //       this.$message.error(res.msg)
          //     }
          //   })
          // }else{
          //   this.$message.error(this.detailInfo.productName+'药品检测报告未上传，请检查。')
          // }

        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    onFacility() {
      this.dialogVisible = true
    },
    selectData(data) {
      console.log("获取的数据======", data)
      // this.$set(this.detailForm,'sponsorName',data[0].groupName)
      // this.$set(this.detailForm,'sponsorCode',data[0].groupCode)
      // this.$refs.detailForm.clearValidate('sponsorName');
      // this.$set(this.detailForm,'aslGroupCode',"")
      // this.getAslGroup(data[0].groupCode)

      this.dialogVisible = false
    },
    getAslGroup(id, aslGroupCode) {
      aslApi.aslGroup({}, id).then((res) => {
        console.log("查看group的数据=====", res)
        if (res.code == 200) {
          this.aslGroupCodeList = res.data
          var codeLists = res.data.map(ele => {
            return ele.aslGroupCode
          })
          console.log('codeLists', codeLists);
          if (!codeLists.includes(aslGroupCode) && this.$route.query.id) {
            this.aslGroupCodeList.push({
              aslGroupCode: this.detailInfo.aslGroupCode,
              aslGroupName: this.detailInfo.aslGroupName,
              enabled: false,
              sponsorCode: id,
            })
          }
          // if(aslGroupCode) {
          //   this.getBreedingModeList(aslGroupCode)
          // }
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    routerBack() {
      this.$router.back();
    },
    getOther(val) {
      console.log("查看下拉框是否其他=====", val)
      if (val == '其他') {
        this.isOther = true
        this.$set(this.detailInfo, 'medicineLevelOneGrade', "")
        this.$set(this.detailInfo, 'medicineLevelTwoGrade', "")
        this.$set(this.detailInfo, 'whoMedicineGrade', "")
        this.$set(this.detailInfo, 'oieMedicineGrade', "")
      } else {
        this.isOther = false
      }
      if (val) {
        let params = {
          effectiveComponents: val
        }
        proteinDrug.queryNature(params).then((res) => {
          this.$set(this.detailInfo, 'medicineLevelOneGrade', res.data.medicineLevelOneGrade)
          this.$set(this.detailInfo, 'medicineLevelTwoGrade', res.data.medicineLevelTwoGrade)
          this.$set(this.detailInfo, 'whoMedicineGrade', res.data.whoMedicineGrade)
          this.$set(this.detailInfo, 'oieMedicineGrade', res.data.oieMedicineGrade)
        })
      }
    }
  },
  extends: commonFunction
}
</script>
<style scoped >
.searchForm .el-col {
  margin-top: 10px;
}
.info_box_title {
  height: 30px;
  margin-top: 10px !important;
  display: flex;
  flex-direction: row;
  justify-content: start;
}
.line {
  width: 3px;
  height: 16px;
  margin: 7px 0;
  background-color: #f8ab01;
}
.info_title {
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  height: 30px;
  line-height: 30px;
  font-size: 16px;
  font-weight: bold;
  margin-left: 5px;
}
</style>
